import Header from '../componets/header/header';
import Footer from '../componets/footer/footer';
import aboutbackground from "../../assests/about_background.webp"; // Corrected 'assests' to 'assets'
import about from "../../assests/about_image.png";
import person1 from "../../assests/internship/person1.png";
import person2 from "../../assests/internship/person2.png";
function AboutPage() {
    return (
        <div>
            <Header />
            <div>


                <div style={{ position: "relative", textAlign: "center", color: "white" }}>
                    {/* Background Image */}
                    <img
                        src={aboutbackground}
                        alt="Digital Marketing"
                        style={{
                            width: "100%",
                            height: "70vh",
                            objectFit: "cover",
                        }}
                    />

                    {/* Overlay */}
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "70vh",
                            backgroundColor: "rgba(0, 0, 0, 0.35)",
                            zIndex: 1,
                        }}
                    ></div>
                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 2,
                        }}
                    >
                        <h1
                            style={{
                                fontSize: "50px",
                                fontWeight: "900",
                                color: "rgb(0, 195, 255)",
                                margin: 0,
                            }}
                        >
                            About Us
                        </h1>
                        <p style={{ color: "#fff", fontSize: "18px", marginTop: "10px" }}>
                            Inspired by the world, created for you, Digital Marketing Agency in Kochi
                        </p>
                    </div>
                </div>
                <div>    <div className="stats-row">
                    <div className="stat-box" data-aos="fade-up">
                        <span className="stat-value">500+</span>
                        <h5 className="stat-label">HAPPY STUDENTS</h5>
                    </div>
                    <div className="stat-box" data-aos="fade-up" data-aos-delay="100">
                        <span className="stat-value">400+</span>
                        <h5 className="stat-label">PLACED STUDENTS</h5>
                    </div>
                    <div className="stat-box" data-aos="fade-up" data-aos-delay="200">
                        <span className="stat-value">50+</span>
                        <h5 className="stat-label">TEAM MEMBERS</h5>
                    </div>
                    <div className="stat-box" data-aos="fade-up" data-aos-delay="300">
                        <span className="stat-value">7+</span>
                        <h5 className="stat-label">YEARS OF EXPERIENCE</h5>
                    </div>
                </div>
                    <div className="about-section-wrapper">
                        <div className="about-left">
                            <img src={person1} className="responsive-image" alt="Descriptive Alt Text" />
                        </div>
                        <div className="about-right">
                            {/* <h6 className="about-subtitle">About Us</h6> */}
                            <h2 className="about-title">
                                WHO WE ARE
                            </h2>
                            <div className="about-summary">

                                <div className="about-description">
                                    <p>
                                        At Papa Digital Academy, we are more than just a technology company - we are your trusted
                                        partners in navigating the digital landscape.
                                        Our mission is to empower businesses and individuals by providing innovative, tailored digital
                                        solutions that drive growth, efficiency, and success.
                                    </p>
                                    <p>
                                        Founded on the principles of creativity, collaboration, and customer-centricity, we pride
                                        ourselves on delivering exceptional value through cutting-edge technology and expert
                                        guidance. Our parent company is helmed by marketing professionals with more than 5+ years
                                        of experience in creative marketing and tech realms. With such vast expertise behind us, papa
                                        digital solution aims to become the go-to destination for students, job seekers, and
                                        professionals looking to boost their digital marketing skills and career prospects.
                                    </p>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="about-section-wrapper">
                        <div className="about-right">
                            {/* <h6 className="about-subtitle"></h6> */}
                            <h2 className="about-title">
                                Building the Future, Together
                            </h2>
                            <div className="about-summary">
                                {/* <img src={about} alt="Who We Are" className="about-main-image" /> */}
                                <div className="about-description">
                                    <p>
                                        Our mission doesn't end with you; we're also passionate about uplifting the
                                        community. Through active participation in government public awareness
                                        campaigns, we aim to inspire a culture of excellence in the local job market,
                                        promoting ethical practices and a growth mindset.By fostering these values, we
                                        aim to create a sustainable, thriving job market that supports the aspirations of
                                        young professionals while contributing to economic growth and development.
                                        Whether you're a young job seeker ready to take on the world, or an experienced
                                        professional looking to make a difference, papa digital Academy and the papa
                                        digital solution's Happiness Project are here to help you reach your goals.


                                    </p>
                                    <p>
                                        Our team believes that quality education should be accessible, affordable, and aligned with current market demands. That's why we constantly
                                        update our curriculum and deliver training that is relevant, practical, and results-driven.
                                    </p>

                                </div>
                            </div>

                        </div>

                        <div className="about-left">
                            <img src={person2} className="responsive-image" alt="Descriptive Alt Text" />

                        </div>
                    </div>
                </div>
                <div className="whatweoffer-container">
                    <div className="offer-image">
                        <img src={about} alt="What We Offer" />
                    </div>
                    <div className="offer-content">
                        <h2>Why Join Us?</h2>
                        <ul>
                            <li> Real-world experience through live projects</li>
                            <li> Mentorship from industry experts</li>
                            <li>Flexible learning for students, professionals, and entrepreneurs</li>
                            <li>Opportunities to grow in digital marketing and beyond</li>
                            <p>At papa digital Academy, we believe in the power of innovation and the
                                importance of quality education. Join us, and let's build a bright, successful
                                future together!</p>
                        </ul>
                    </div>
                </div>
            </div>
            <Footer />
        </div >
    );
}

export default AboutPage;
